import { z } from 'zod';

export enum VoltageUnit {
  V = 0,
  KV = 3,
  MV = 6,
}

export const VoltageUnitSchema = z.nativeEnum(VoltageUnit);
